import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export function useSite() {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/site");
      setSite(data);
      setError(null);
    } catch (e) {
      setError(e?.message || "Error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { site, loading, error, reload: load, setSite };
}
